export default {
  label: {
    id: 'resolution_flow_return_confirmation_page_cta_print_proof_of_purchase',
    defaultMessage: 'Print proof of purchase',
  },
}
